import styled from 'styled-components';
import Colors from './Colors';

const Button = styled.button`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  width: 100%;
  max-height: 100%;
  height: 40px;
  background-color: ${Colors.VIOLET_PURP};
  border-radius: 200px;
  color: white;
  font-size: 2vh;
  border: none;
  position: relative;
  z-index: 11;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;

  /* Accessibility: Focus visible styles */
  &:focus-visible {
    outline: 3px solid ${Colors.VIOLET_PURP};
    outline-offset: 2px;
    box-shadow: 0 0 0 3px rgba(138, 43, 226, 0.3);
  }

  /* Accessibility: Remove outline for mouse users */
  &:focus:not(:focus-visible) {
    outline: none;
  }

  /* Hover state for better UX */
  &:hover:not(:disabled) {
    background-color: #7a2db8;
    transform: translateY(-1px);
  }

  /* Active/pressed state */
  &:active:not(:disabled) {
    transform: translateY(0);
  }

  /* Disabled state */
  :disabled {
    background-color: ${Colors.DEMO_GREY};
    cursor: not-allowed;
    opacity: 0.6;
  }

  /* Reduce motion for users who prefer it */
  @media (prefers-reduced-motion: reduce) {
    transition: none;
    transform: none !important;
  }
`;

export default Button;
